import ENG from './ENG.json';
import PRT from './PRT.json';

export const expressions = {
  PRT,
  ENG,
};

export const getBrowserLocale = () => {
  // navigator.languages:    Chrome & FF
  // navigator.language:     Safari & Others
  // navigator.userLanguage: IE & Others
  const [code] = navigator.languages || [
    navigator.language || navigator.userLanguage,
  ];

  const isLanguageSupported = Object.keys(expressions).find(
    (element) => element === code,
  );
  if (isLanguageSupported === undefined) {
    return 'pt-PT';
  }

  return code;
};

export const getBrowserLocales = (options = {}) => {
  const defaultOptions = {
    languageCodeOnly: false,
  };
  const opt = {
    ...defaultOptions,
    ...options,
  };
  const browserLocales =
    navigator.languages === undefined
      ? [navigator.language]
      : navigator.languages;
  if (!browserLocales) {
    return ['pt-PT'];
  }
  return browserLocales.map((locale) => {
    const trimmedLocale = locale.trim();
    return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
  });
};
